@if (moderatedChat) {
  @if (isHostFeed) {
    <app-host-chat-feed></app-host-chat-feed>
  } @else if (isModerationFeed) {
    <app-moderation-chat-feed></app-moderation-chat-feed>
  } @else {
    <app-chat-feed
      [moderatedChat]="moderatedChat"
      [chatModerationSetting]="chatModerationSetting"
      [hostChatSetting]="hostChatSetting"
    ></app-chat-feed>
  }
} @else {
  <app-chat-feed></app-chat-feed>
}
